import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'

import SettingContext from '@/product/context/setting/settingContext'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
let randomVariable = Math.random()
const PaymentUploadFile = () => {
    const settingContexts = useContext(SettingCustomContext)
    const [tableBody, setTableBody] = useState([])
    const [tableValues, setTableValues] = useState([])
    const [countData, setCountData] = useState({})
    const [invoiceNotesStatus, setInvoiceNotesStatus] = useState(false)
    const { transactionDbUpload, responseStatus, showPaymentTempData } =
        settingContexts
    const [isLoading, setIsLoading] = useState(false)
    const validationArray = Yup.object({
        uploadFiles: Yup.array().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            uploadFiles: [],
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            // let value = values
            // value.ignoreFields = props.ignoreFields
            // value.preFillFields = props.preFillFields ? props.preFillFields : {}
            // value.fillIDFields = props.fillIDFields ? props.fillIDFields : []
            // value.quick = props?.quick || false
            transactionDbUpload(values)
        },
    })

    useEffect(() => {
        if (formik.values.uploadFiles && formik.values.uploadFiles.length) {
            randomVariable = Math.random()
            showPaymentTempData(formik.values)
        } else {
            setTableBody([])
        }
    }, [formik.values.uploadFiles])

    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from == 'showPaymentTempData' &&
                responseStatus.status == 'success'
            ) {
                if (
                    responseStatus.data &&
                    responseStatus.data.records &&
                    responseStatus.data.records.length
                ) {
                    let firstData = responseStatus.data.records[0]
                    let headers = Object.keys(firstData)
                    let tableHeaderFormation = headers.map((ele) => {
                        let obj = {
                            field: ele,
                            type: '',
                            firstChild: true,
                            sort: false,
                            disablePadding: false,
                            label: ele,
                        }
                        return obj
                    })
                    setTableValues(tableHeaderFormation)
                    responseStatus.data.records.map((el, index) => {
                        el.id = index
                    })
                    setTableBody(responseStatus.data.records)
                }
            } else if (
                responseStatus.from == 'SearchTable' &&
                responseStatus.status == 'success'
            ) {
                if (responseStatus.data) {
                    setCountData(responseStatus.data?.count || {})
                    toggleInvoiceModal()
                }
            }
            setIsLoading(false)
        }
    }, [responseStatus])
    const productListing = [
        {
            type: 'uploadDropZone',
            formik: formik,
            name: 'uploadFiles',
            titleText: 'Upload CSV document *',
            class: 'col-12',
            folder: 'temp',
            multiple: false,
            accept: '.csv',
        },
    ]
    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 100,
            searchterm: '',
        },
        onSubmit: (values) => {},
    })
    const toggleInvoiceModal = () => {
        setInvoiceNotesStatus(!invoiceNotesStatus)
    }
    return (
        <Layout>
            {/* <div className="dashboard staticPages"> */}
            {/* <div className="d-flex justify-content-between align-items-center mt-0 mb-4"> */}
            <h2>Merchant Warrior</h2>
            <h4>Upload the csv File</h4>
            <div> {Object.values(mapData(productListing))}</div>
            <PrimaryButton
                id="location_add"
                // variant="outlined"
                // className="btnOutlined"
                onClick={formik.handleSubmit}
            >
                Upload File <span className="material-icons">file_upload</span>
            </PrimaryButton>
            {tableBody.length ? (
                <CustomTable
                    enableTableView={true}
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    hidePaginationView={true}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    tableActions={[]}
                    allData={{
                        records: tableBody,
                        setDisp: `0-${formikView.values.limit}`,
                        totalRecords: formikView.values.limit,
                    }}
                    changeTableFunction={() => {}}
                />
            ) : null}

            <CustomDialog
                title="Invoice notes"
                open={invoiceNotesStatus}
                className="invoiceNotes"
                function={toggleInvoiceModal}
            >
                <h5>
                    {countData.total} Record(s) Uploaded From Payment Processor
                    File.
                    <br />
                    {countData.new} Bond Roberts Transaction Record(s) Updated.
                    <br />
                    {countData.notFound} Record(s) Not Found In System And Not
                    Updated.
                    <br />
                    {countData.duplicate} Record(s) Found As Duplicate And Not
                    Updated.
                </h5>

                <div className="actionWrapper">
                    <PrimaryButton
                        onClick={() => {
                            formik.setFieldValue('uploadFiles', [])
                            toggleInvoiceModal()
                        }}
                        type="submit"
                        label="ok"
                    />
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default PaymentUploadFile
